function search(event) {
  event.preventDefault();
  let searchInputElement = document.querySelector("#search-input");
  let cityElement = document.querySelector("#city");
  cityElement.innerHTML = searchInputElement.value;
  searchCity(searchInputElement.value);
}

function formatDate(date) {
  let minutes = date.getMinutes();
  let hours = date.getHours();
  let day = date.getDay();

  if (minutes < 10) minutes = `0${minutes}`;

  if (hours < 10) hours = `0${hours}`;

  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  let formattedDay = days[day];
  return `${formattedDay} ${hours}:${minutes}`;
}

function formattedDay(timestamp) {
  let date = new Date(timestamp * 1000);
  let day = date.getDay();
  let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return days[day];
}

let searchFormElement = document.querySelector("#search-form");
searchFormElement.addEventListener("submit", search);

let currentDateElement = document.querySelector("#date");
let currentDate = new Date();
currentDateElement.innerHTML = formatDate(currentDate);

function searchCity(city) {
  let apiKey = "a16ob917f988d0b7fd435d6b9d4a73ft";
  let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
  axios.get(apiUrl).then(displayWeather);
}

function displayWeather(response) {
  let cityElement = document.querySelector("#city");
  let temperatureElement = document.querySelector("#temperature");
  let descriptionElement = document.querySelector("#description");
  let humidityElement = document.querySelector("#humidity");
  let windSpeedElement = document.querySelector("#wind-speed");
  let timeElement = document.querySelector("#time");
  let iconElement = document.querySelector("#icon");

  let date = new Date(response.data.time * 1000);

  cityElement.innerHTML = response.data.city;
  temperatureElement.innerHTML = `${Math.round(
    response.data.temperature.current
  )}°C`;
  descriptionElement.innerHTML = response.data.condition.description;
  humidityElement.innerHTML = `${response.data.temperature.humidity}%`;
  windSpeedElement.innerHTML = `${response.data.wind.speed} m/s`;
  timeElement.innerHTML = formatDate(date);
  iconElement.innerHTML = `<img src="${
    response.data.condition.icon_url
  }" class="weather-icon" alt="${response.data.condition.description}"/>
  <span class="current-temperature-value" id="temperature-value">${Math.round(
    response.data.temperature.current
  )}</span>
  <span class="current-temperature-unit" id="unit">°C</span> `;

  fetchForecast(response.data.city);
}

function fetchForecast(city) {
  let apiKey = "a16ob917f988d0b7fd435d6b9d4a73ft";
  let apiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${city}&key=${apiKey}&units=metric`;
  axios.get(apiUrl).then(updateForecast);
}

function updateForecast(response) {
  let forecastHtml = "";
  response.data.daily.forEach(function (day, index) {
    if (index < 5) {
      forecastHtml += `
        <div class="forecast-day">
          <div class="forecast-date">${formattedDay(day.time)}</div>
          <div class="forecast-icon">
            <img src="${day.condition.icon_url}" alt="${
        day.condition.description
      }" />
          </div>
          <div class="forecast-temperatures">
            <strong>${Math.round(day.temperature.maximum)}°</strong>
            <span>${Math.round(day.temperature.minimum)}°</span>
          </div>
        </div>`;
    }
  });
  document.querySelector("#forecast").innerHTML = forecastHtml;
}
searchCity("Paris");
fetchForecast("Paris");
